import { refractor } from 'refractor';
import highlight from './highlight';
import supportedLanguages from './languages/prism/supported-languages';
import uorazor from './languages/prism/uorazor';
import defaultStyle from './styles/prism/funky';
refractor.register(uorazor)
const SyntaxHighlighter = highlight(refractor, defaultStyle);

SyntaxHighlighter.supportedLanguages = supportedLanguages;

export default SyntaxHighlighter;
